module.exports = {

  changeUserData: {
    title: "Update data",
    firstName: 'First name',
    lastName: 'Last name',
    phoneNumber: 'Phone number',
    companyName: 'Company name',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    postalCode: 'Postal code',
    taxNumber: 'Tax number',
    country: 'Country',
    city: 'City',
    submit: "Save",
    errors: {

    },
    done: {
      title: "Update data",
      text: "Data successfully saved."
    }
  },

  logout: {
    title: "Logout",
    working: {
      title: "Logout in progress",
      text: "Please wait..."
    },
    done: {
      title: "Logout",
      text: "You have been successfully logged out."
    },
    login: "Login again"
  }

}


// WEBPACK FOOTER //
// ../i18n/en/user.js